







import { Component, Vue } from 'vue-property-decorator';
import { userModule } from '@/store/modules/ModuleUser';

@Component({
	name: 'App'
})
/** App */
export default class App extends Vue {
	/** mounted */
	public mounted(): void {
		const histroryItem: any = window.history;
		if (histroryItem && histroryItem.pushState) {
			// 向历史记录中插入了当前页
			// history.pushState(null, 'null', document.URL);
			window.addEventListener('popstate', this.goBack, false);
		}
	}

	/** 是否显示水印 */
	public get showWaterMarker(): boolean {
		// 不显示水印的页面数组
		const noWaterMarkerPage = ['homePage'];

		return !noWaterMarkerPage.includes(this.$route.name ?? '');
	}

	/** 水印内容 */
	public get content(): string {
		return userModule?.userData?.name ?? '';
	}

	/** hook */
	public destroyed(): void {
		window.removeEventListener('popstate', this.goBack, false);
	}

	/** hook */
	public goBack(e: any): void {
		// console.log('点击了浏览器的返回按钮', e);
		// history.pushState(null, 'null', document.URL);
		if (window.stateLock) {
			return;
		}

		const windowObj: any = window;
		windowObj.location.reload(true);
	}
}
